export function getViewName(url) {
    const index = url.indexOf('@@');
    if (index !== -1) {
        const result = url.substring(index);
        return result;
    } else {
        console.log("Nessuna occorrenza di @@ trovata");
    }
}
